module.exports = __webpack_public_path__ + "static/assets/d667efad2534ade6f4b440ed816ff039.png";